// Used in TimeSlotPlannerStep and NewTreatmentPlanningStep
function createSortedTimeWindow(timeFrom, timeTo, timeWindow) {
  return {
    time_from: timeFrom,
    time_to: timeTo,
    timewindow: timeWindow,
  };
}

export function createSortedAvailableTimeWindows(availableTimeWindows) {
  const sortedArray = {};
  for (let i = 0; i < availableTimeWindows.length; i++) {
    const splitFromDate = availableTimeWindows[i].date_time_from.split(" ");
    const splitToDate = availableTimeWindows[i].date_time_to.split(" ");

    if (sortedArray[splitFromDate[0]] == null)
      sortedArray[splitFromDate[0]] = [
        createSortedTimeWindow(
          splitFromDate[1],
          splitToDate[1],
          availableTimeWindows[i],
        ),
      ];
    else
      sortedArray[splitFromDate[0]].push(
        createSortedTimeWindow(
          splitFromDate[1],
          splitToDate[1],
          availableTimeWindows[i],
        ),
      );
  }
  return sortedArray;
}
